import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { takeSquabReturn } from "@/lib/squab";
import { Layout } from "@/components/Layout";

export default function Auth() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ email: "", password: "", name: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const path = mode === "login" ? "/auth/login" : "/auth/register";
      const payload = mode === "login" ? { email: form.email, password: form.password } : form;
      const { data } = await api.post(path, payload);
      setUser(data);
      toast.success(`Welcome${data.name ? ", " + data.name.split(" ")[0] : ""}!`);
      navigate(takeSquabReturn("/"));
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/profile";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <Layout>
      <div className="max-w-md mx-auto px-5 py-16">
        <div className="border-2 border-white/20 bg-card p-8 brutal-shadow-sm">
          <h1 className="font-display text-4xl mb-1">{mode === "login" ? "SIGN IN" : "SIGN UP"}</h1>
          <p className="text-muted-foreground text-sm mb-7">{mode === "login" ? "Drop back into the culture." : "Create your Hip Hop Knowledge Drop account."}</p>

          <button onClick={googleLogin} data-testid="google-login-btn"
            className="w-full flex items-center justify-center gap-2 border border-white/30 py-3 mb-5 font-mono-caps text-[11px] hover:border-primary transition-colors">
            <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="w-4 h-4" /> Continue with Google
          </button>
          <div className="flex items-center gap-3 mb-5">
            <div className="h-px flex-1 bg-white/10" /><span className="font-mono-caps text-[9px] text-muted-foreground">or email</span><div className="h-px flex-1 bg-white/10" />
          </div>

          <form onSubmit={submit} className="space-y-4">
            {mode === "register" && (
              <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Display name" data-testid="auth-name"
                className="w-full bg-background border border-border px-3 py-3 outline-none focus:ring-2 focus:ring-primary text-sm" />
            )}
            <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Email" data-testid="auth-email"
              className="w-full bg-background border border-border px-3 py-3 outline-none focus:ring-2 focus:ring-primary text-sm" />
            <input required type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="Password" data-testid="auth-password"
              className="w-full bg-background border border-border px-3 py-3 outline-none focus:ring-2 focus:ring-primary text-sm" />
            <button type="submit" disabled={busy} data-testid="auth-submit"
              className="w-full bg-primary text-primary-foreground font-mono-caps text-xs py-3.5 border border-primary hover-lift disabled:opacity-50">
              {busy ? "..." : mode === "login" ? "Sign In" : "Create Account"}
            </button>
          </form>
          {mode === "login" && (
            <Link to="/forgot-password" data-testid="login-forgot-password-link" className="inline-block mt-4 text-sm text-primary hover:underline font-medium">
              Forgot Password?
            </Link>
          )}

          <p className="mt-6 text-sm text-muted-foreground">
            {mode === "login" ? "New here? " : "Already have an account? "}
            <button onClick={() => setMode(mode === "login" ? "register" : "login")} data-testid="auth-toggle" className="text-primary hover:underline font-medium">
              {mode === "login" ? "Create account" : "Sign in"}
            </button>
          </p>
        </div>
      </div>
    </Layout>
  );
}
